/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import T from 'aegisv2/Text';
import styled from 'styled-components';
import { randomizer } from 'Utils';
import Skeleton from 'Catalog/ui/Skeleton';
import Loadable from 'Shared/Loadable';
import { secondaryMain } from 'crehana-ui/styles/colors';

import { ContainerDesktop, ContainerMobile } from 'Jsx/Catalog/ui/Responsive';
import { CourseCardWrapper } from 'Jsx/Catalog/ui/CourseCardWrapper';
import { ShowMore } from '../ui';

const SkeletonImage = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  padding-bottom: 80%;
`;

const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
`;

const params = {
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 475,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1,
      },
    },
  ],
  arrowTop: 'calc(50% - 24px)',
};

class TracksSlider extends Component {
  state = {
    shouldRender: false,
  };

  componentDidMount() {
    // only render in client-side, custom-swiper has no support for SSR
    this.setState({ shouldRender: true }); // eslint-disable-line
  }

  render() {
    const { shouldRender } = this.state;
    const { tracks, title, link, linkText } = this.props;

    const itemsPerRow = {
      1680: 3,
      1440: 3,
      1280: 3,
      1024: 3,
      768: 2,
    };

    const Loader = (
      <div
        style={{
          display: 'flex',
          overflow: 'hidden',
          flexFlow: 'row nowrap',
        }}
      >
        {Array.from({ length: 3 }).map(() => (
          <CourseCardWrapper
            itemsPerRow={itemsPerRow}
            key={randomizer.getString()}
            onRow
          >
            <SkeletonImage>
              <Skeleton />
            </SkeletonImage>
            <div
              style={{
                position: 'relative',
                height: 24,
                width: '100%',
                marginTop: 6,
              }}
            >
              <Skeleton />
            </div>
            <div
              style={{
                position: 'relative',
                height: 16,
                width: '35%',
                margin: '8px auto 0 0',
              }}
            >
              <Skeleton />
            </div>
          </CourseCardWrapper>
        ))}
      </div>
    );

    return (
      <div>
        <TitleWrapper style={{ marginBottom: 24 }}>
          <T s bold style={{ fontFamily: 'Gilroy, Arial, sans-serif' }}>
            {title}
          </T>
          {link && (
            <ContainerDesktop>
              <a href={link}>
                <T color={secondaryMain} xs bold>
                  {linkText}
                </T>
              </a>
            </ContainerDesktop>
          )}
        </TitleWrapper>
        {!shouldRender ? (
          Loader
        ) : tracks ? (
          <Loadable
            Loader={Loader}
            module={() =>
              import(/* webpackChunkName: "tracks-slider" */ './Slider')
            }
            params={params}
            tracks={tracks}
          />
        ) : null}
        <ContainerMobile>
          <ShowMore href={link}>
            <T size={13.86} color={secondaryMain} xs bold>
              {linkText}
            </T>
          </ShowMore>
        </ContainerMobile>
      </div>
    );
  }
}

export default TracksSlider;
